import React, { useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { Col, Row } from 'antd';
import useStyles from '../../reusable-component/styles';

export default function GrantClient() {
  const classes = useStyles();
  const [selectedUser, setSelectedUser] = useState('');
  const [selectedClient, setSelectedClient] = useState('');
  const [selectedAccessRight, setSelectedAccessRight] = useState('');
  const [selectedUserError, setSelectedUserError] = useState('');
  const [selectedClientError, setSelectedClientError] = useState('');
  const [selectedAccessRightError, setSelectedAccessRightError] = useState('');

  const userList = [
    {
      user_id: '802fcc1c-7984-427f-b715-79f9ea8ab679',
      user_name: 'John Doe',
    },
    {
      user_id: '7d09f7e2-603e-4d09-8490-1b7c14d9feeb',
      user_name: 'Karen',
    },
  ];

  const clientList = [
    {
      client_id: '802fcc1c-7984-427f-b715-79f9ea8ab679',
      client_name: 'qwerty',
    },
    {
      client_id: '7d09f7e2-603e-4d09-8490-1b7c14d9feeb',
      client_name: 'Customer360',
    },
  ];

  const accessRightsList = [
    {
      access_id: '802fcc1c-7984-427f-b715-79f9ea8ab679',
      access_type: 'Admin',
    },
    {
      access_id: '7d09f7e2-603e-4d09-8490-1b7c14d9feeb',
      access_type: 'Reader',
    },
  ];

  const handleOnUserChange = (event) => {
    setSelectedUser(event.target.value);
    setSelectedUserError('');
  };

  const handleOnClientChange = (event) => {
    setSelectedClient(event.target.value);
    setSelectedClientError('');
  };

  const handleOnAccessRightChange = (event) => {
    setSelectedAccessRight(event.target.value);
    setSelectedAccessRightError('');
  };

  const handleClear = () => {
    setSelectedUser('');
    setSelectedClient('');
    setSelectedAccessRight('');
    setSelectedUserError('');
    setSelectedClientError('');
    setSelectedAccessRightError('');
  };

  const handleSubmit = () => {
    if (selectedClient === '' || selectedUser === '' || selectedAccessRight === '') {
      setSelectedClientError(selectedClient === '' ? 'Client is required.' : '');
      setSelectedUserError(selectedUser === '' ? 'User is required.' : '');
      setSelectedAccessRightError(selectedAccessRight === '' ? 'Access Rights is required.' : '');
      enqueueSnackbar('Please complete all required fields !', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
      return;
    }

    setSelectedUserError('');
    setSelectedClientError('');
    setSelectedAccessRightError('');

    enqueueSnackbar('Service incomplete: Frontend or backend code still in progress !', {
      variant: 'warning',
      autoHideDuration: 5000,
      anchorOrigin: { vertical: 'top', horizontal: 'right' },
    });
  };

  const columnStyle = { marginBottom: '8px', marginTop: '8px' };
  const paperStyle = {
    padding: '20px',
    minHeight: '3rem',
    '@media (max-width: 600px)': {
      minHeight: '5rem',
    },
    '@media (min-width: 601px) and (max-width: 1090px)': {
      minHeight: '4.5rem',
    },
  };

  return (
    <Box>
      <Paper elevation={3} className={classes.paper} style={paperStyle}>
        <Box>
          <Typography variant="h5" component="h5" className={classes.pageTitle}>
            Grant Client Access
          </Typography>
          <Typography fontSize={11} className={classes.pageText}>
            Enter details to provide access to the user
          </Typography>
        </Box>
        <Row gutter={36}>
          <Col xs={24} sm={12} md={6} lg={6} xl={6} style={columnStyle}>
            <FormControl fullWidth error>
              <Typography
                variant="p"
                component="p"
                display="flex"
                alignContent="flex-start"
                sx={{ color: '#8798AD', fontSize: '11px' }}
              >
                User*
              </Typography>
              <Select
                size="small"
                labelId="user-name"
                id="user-name"
                value={selectedUser}
                onChange={handleOnUserChange}
                error={!!selectedUserError}
                helperText={selectedUserError}
                input={<OutlinedInput />}
                sx={{ backgroundColor: '#2E5BFF14', height: '40px' }}
              >
                {userList.map((item) => (
                  <MenuItem key={item.user_id} value={item.user_name}>
                    {item.user_name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{selectedUserError}</FormHelperText>
            </FormControl>
          </Col>
          <Col xs={24} sm={12} md={18} lg={18} xl={18} />
          <Col xs={24} sm={12} md={6} lg={6} xl={6} style={columnStyle}>
            <FormControl fullWidth error>
              <Typography
                variant="p"
                component="p"
                display="flex"
                alignContent="flex-start"
                sx={{ color: '#8798AD', fontSize: '11px' }}
              >
                Client*
              </Typography>
              <Select
                size="small"
                labelId="user-name"
                id="user-name"
                value={selectedClient}
                onChange={handleOnClientChange}
                error={!!selectedClientError}
                helperText={selectedClientError}
                input={<OutlinedInput />}
                sx={{ backgroundColor: '#2E5BFF14', height: '40px' }}
              >
                {clientList.map((item) => (
                  <MenuItem key={item.client_id} value={item.client_name}>
                    {item.client_name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{selectedClientError}</FormHelperText>
            </FormControl>
          </Col>
          <Col xs={24} sm={12} md={6} lg={6} xl={6} style={columnStyle}>
            <FormControl fullWidth error>
              <Typography
                variant="p"
                component="p"
                display="flex"
                alignContent="flex-start"
                sx={{ color: '#8798AD', fontSize: '11px' }}
              >
                Access Rights*
              </Typography>
              <Select
                size="small"
                labelId="user-name"
                id="user-name"
                value={selectedAccessRight}
                onChange={handleOnAccessRightChange}
                error={!!selectedAccessRightError}
                helperText={selectedAccessRightError}
                input={<OutlinedInput />}
                sx={{ backgroundColor: '#2E5BFF14', height: '40px' }}
              >
                {accessRightsList.map((item) => (
                  <MenuItem key={item.access_id} value={item.access_type}>
                    {item.access_type}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{selectedAccessRightError}</FormHelperText>
            </FormControl>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} />
        </Row>

        {/* <Stack direction="row">
        <AddClientDetailEngagement text="1" clientIcon={clientIcon} engagementIcon={engagementIcon} />
        <Divider className={classes.divider} />
        <AddClientDetailEngagement text="2" clientIcon={clientIcon} engagementIcon={engagementIcon} />
      </Stack> */}
        {/* <Stack direction="row">
        <Typography variant="p" component="p" fontSize={12}>
          {CLIENT_ONBOARD.clientDetails}
        </Typography>
        <Typography variant="p" component="p" fontSize={12} ml={10.8}>
          {CLIENT_ONBOARD.engagementDetail}
        </Typography>
      </Stack> */}
      </Paper>
      <Stack direction="row" alignItems="flex-end" justifyContent="flex-end" spacing={2} sx={{ paddingTop: 2 }}>
        {(selectedUser || selectedClient || selectedAccessRight) && (
          <Button
            size="small"
            type="submit"
            variant="outlined"
            sx={{ textTransform: 'capitalize', color: '#43425D', border: '1px solid #43425D' }}
            onClick={handleClear}
          >
            Clear
          </Button>
        )}
        <Button
          size="small"
          type="submit"
          variant="contained"
          sx={{ backgroundColor: '#00043C', textTransform: 'capitalize', '&:hover': { backgroundColor: '#00043C' } }}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </Stack>
    </Box>
  );
}
